import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { startsWith } from 'lodash';
import { trackStateChanged } from '../../factories/analytics/analytics.service';

const Analytics = ({ basename }) => {
  const location = useLocation();

  const [prevPathname, setPrevPathname] = useState('');

  useEffect(() => {
    const currentToPath = location.pathname.replace(`${basename}/`, '');
    const isModalClosed = startsWith(prevPathname, currentToPath);
    const simpleDetailsModalRegex = RegExp(
      'trims[/]features[/]\\w*[/](option|package)[/]\\w*'
    );
    const isSimpleDetailModal = location.pathname.match(
      simpleDetailsModalRegex
    );

    if (prevPathname !== currentToPath) {
      trackStateChanged(currentToPath, isModalClosed || isSimpleDetailModal);
      setPrevPathname(currentToPath);
    }
  }, [location]);

  return null;
};

export default Analytics;
